'use strict';

angular.module('app')
    .controller('RecipeController', ['$scope', '$stateParams', 'Recipe', 'RecipeService', 'PrinterConfig', 'Allergen', '$q', '$translate', function ($scope, $stateParams, Recipe, RecipeService, PrinterConfig, Allergen, $q, $translate) {
        $scope.scales = RecipeService.getScales();
        
        // augment translatedName for scales;
        _.forEach($scope.scales, function (scale) {
            scale.displayName = scale.translationKey ? $translate.instant(scale.translationKey) : scale.name;
        });
        
        $scope.scale = _.find($scope.scales, {id: 1});

        var promises = [
            Recipe.get({id: $stateParams.id}).$promise,
            Allergen.query().$promise,
            PrinterConfig.current().$promise
        ];

        // Augment the ingredients
        var handleAllergens = function (results) {
            $scope.recipe = results[0];
            var allergens = results[1];

            _.forEach($scope.recipe.ingredients, function (i) {
                i.allergens = [];
                _.forEach(allergens, function (a) {
                    _.forEach(a.products, function (p) {
                        if (p && i.inputProduct && (p.id === i.inputProduct.id)) {
                            i.allergens.push(a);
                            return false;
                        }
                    });
                    _.forEach(a.recipes, function (r) {
                        if (r && i.inputRecipe && (r.id === i.inputRecipe.id)) {
                            i.allergens.push(a);
                            return false;
                        }
                    });
                });
                i.allergensList = _.chain(i.allergens).map('name').join(', ').value();
            });
            $scope.utensilName = _.chain($scope.recipe.utensils).map('utensil').map('name').join(', ').value();
        };

        $q.all(promises).then(function (results) {
            handleAllergens(results);
            $scope.hasPrinterConfig = !_.isNil(_.get(results[2], 'printerIpAddress'));
            Recipe.queryMethod({id: $scope.recipe.conceptRecipeId}).$promise.then(function (data) {
                $scope.methodSteps = data.methodSteps;
            });
        });

        $scope.notPrimary = function (i) {
            return ($scope.recipe.picture && $scope.recipe.picture.key === i.key) ? false : true;
        };

        $scope.handleAllergenShow = function (i) {
            $(i).popover({trigger: 'focus'});
            return true;
        };
        
        $scope.handleNotesShow = function (i) {
            $(i).popover({trigger: 'focus'});
            return true;
        };
    }]);